import { render, staticRenderFns } from "./Page07NewEASub.vue?vue&type=template&id=1ab0f4dc&scoped=true&"
import script from "./Page07NewEASub.vue?vue&type=script&lang=js&"
export * from "./Page07NewEASub.vue?vue&type=script&lang=js&"
import style0 from "./Page07NewEASub.vue?vue&type=style&index=0&id=1ab0f4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab0f4dc",
  null
  
)

export default component.exports
import {QCard,QCardSection,QTabPanels,QTabPanel,QCircularProgress,QTooltip,QList,QItem,QItemSection,QIcon,QSeparator,QTabs,QTab,QItemLabel,QScrollArea,QDialog,QBar,QSpace,QBtn,QMarkupTable,QTable,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QTabPanels,QTabPanel,QCircularProgress,QTooltip,QList,QItem,QItemSection,QIcon,QSeparator,QTabs,QTab,QItemLabel,QScrollArea,QDialog,QBar,QSpace,QBtn,QMarkupTable,QTable}, component.options.components || {})
component.options.directives = Object.assign({Ripple,ClosePopup}, component.options.directives || {})
